import { useState } from "react";
import { ArrowRight, Star } from "lucide-react";
import Lightbox from "@/components/Lightbox";

const PROJECTS = [
    { id: "gonher", title: "Gonher Industrial", meta: "Industrial · 1,210 m²", city: "Monterrey", type: "Skycover", featured: true, img: "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/e2b53bd47c3ce0556b2b65e4e4debf816e6309861b513812a90ef262dcc74839.jpeg" },
    { id: "torre-benavides", title: "Torre Benavides", meta: "Terraza médica", city: "Monterrey", type: "Skycover", img: "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/c029578d93edd7076dceb123fd2ffb5942015c02eab0e78e5adf938d6536c845.jpeg" },
    { id: "flamatec", title: "Flamatec", meta: "Industrial · 300 m²", city: "Saltillo", type: "FlexShade", img: "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/689154a9e199c8fdd9a966461b3697ce1d0f26221866aeccbf51f7ce4c9722d2.jpeg" },
    { id: "gradas-escolares", title: "Gradas Escolares", meta: "Educativo · 35 m²", city: "Monterrey", type: "FlexShade", img: "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/7955f8ca37334ad15bb681274c15e4229c09fc155ff4a088f7cdb4d89c9631ce.jpeg" },
    { id: "estacionamiento-curve", title: "Estacionamiento Curve", meta: "Comercial", city: "Monterrey", type: "FlexShade", featured: true, img: "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/e58e17e4949a4739e701bcfbbb9f59bccb90e8f56a88b0f10e089059b7e11238.jpeg" },
    { id: "cancha-padel", title: "Cancha de Pádel", meta: "Deportivo", city: "Monterrey", type: "Skycover", img: "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/403303f408cf62b819015795a5133181559b5e4844ff766111dba141564ad666.jpeg" },
    { id: "plaza-comercial", title: "Plaza Comercial", meta: "Comercial", city: "Saltillo", type: "Skycover", img: "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/bf5157e22cba8eb3a8e30878ef4d0e9354fd2e8fe2a8a6fe832572567584aa34.jpeg" },
    { id: "centro-educativo", title: "Centro Educativo", meta: "Educativo", city: "Guadalajara", type: "Skycover", img: "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/df0e9def9538a419c82546444b9a8fdf9168a6276a6bcdebc699d5ec4e8b3d6b.jpeg" },
    { id: "residencia-premium", title: "Residencia Premium", meta: "Residencial", city: "Monterrey", type: "Skycover", img: "https://static.prod-images.emergentagent.com/jobs/48bc66d4-e137-48bf-811d-bee5c078c182/images/f8cd1b410459e0cc0b008ede99bf3697012b80760bd1926172e9c96cd2ad9732.jpeg" },
];

export default function FeaturedProjects() {
    const [lightboxIndex, setLightboxIndex] = useState(null);

    const open = (i) => setLightboxIndex(i);
    const close = () => setLightboxIndex(null);
    const prev = () => setLightboxIndex((i) => (i - 1 + PROJECTS.length) % PROJECTS.length);
    const next = () => setLightboxIndex((i) => (i + 1) % PROJECTS.length);

    return (
        <section id="proyectos" data-testid="featured-projects" className="bg-white py-20 sm:py-28">
            <div className="container-eclipse">
                <div className="max-w-3xl mb-14">
                    <p className="font-display font-bold text-xs tracking-[0.3em] text-eclipse-cta mb-3">CASOS REALES</p>
                    <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-eclipse-primary tracking-tight leading-tight mb-4">Algunos de nuestros proyectos</h2>
                    <p className="text-base sm:text-lg text-eclipse-muted leading-relaxed">Más de 10,000 techos instalados en México y Latinoamérica.</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {PROJECTS.map((p, i) => (
                        <button
                            key={p.id}
                            onClick={() => open(i)}
                            data-testid={`project-card-${p.id}`}
                            className="group relative overflow-hidden rounded-sm bg-eclipse-primary aspect-[4/3] cursor-pointer card-hover-lift text-left"
                        >
                            <img
                                src={p.img}
                                alt={`${p.title} - Proyecto ${p.type} de ${p.meta.toLowerCase()} en ${p.city} por Eclipse Cubiertas`}
                                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-90 group-hover:opacity-100"
                                loading={i < 3 ? "eager" : "lazy"}
                                decoding="async"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />

                            <div className="absolute top-4 left-4 flex flex-col gap-1.5">
                                <span className={`font-display font-bold text-[10px] tracking-[0.2em] px-2.5 py-1.5 ${p.type === "FlexShade" ? "bg-[#FF6801] text-white" : "bg-white text-eclipse-primary"}`}>
                                    {p.type.toUpperCase()}
                                </span>
                                {p.featured && (
                                    <span className="inline-flex items-center gap-1 bg-eclipse-cta text-white font-display font-bold text-[9px] tracking-[0.15em] px-2 py-1 uppercase">
                                        <Star className="w-2.5 h-2.5 fill-current" /> Destacado
                                    </span>
                                )}
                            </div>

                            <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-6 text-white">
                                <h3 className="font-display font-bold text-xl sm:text-2xl leading-tight mb-1">{p.title}</h3>
                                <p className="text-sm text-white/85">{p.meta} · {p.city}</p>
                            </div>

                            <div className="absolute inset-0 bg-eclipse-primary/80 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <span className="font-display font-bold text-white text-base sm:text-lg inline-flex items-center gap-2">
                                    Ampliar foto
                                    <ArrowRight className="w-4 h-4" />
                                </span>
                            </div>
                        </button>
                    ))}
                </div>

                <div className="text-center mt-12">
                    <a href="#proyectos" data-testid="projects-gallery-cta" className="inline-flex items-center gap-2 text-eclipse-primary hover:text-eclipse-cta font-display font-bold text-sm tracking-wider uppercase border-b-2 border-eclipse-primary hover:border-eclipse-cta pb-1 transition-colors">
                        Ver toda la galería de proyectos
                        <ArrowRight className="w-4 h-4" />
                    </a>
                </div>
            </div>

            <Lightbox
                open={lightboxIndex !== null}
                items={PROJECTS}
                index={lightboxIndex ?? 0}
                onClose={close}
                onPrev={prev}
                onNext={next}
            />
        </section>
    );
}
